function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M75.773 85.755a5.27 5.27 0 1 0 10.54-.002 5.27 5.27 0 0 0-10.54.002m49.808-52.032a5.268 5.268 0 1 0 10.537.002 5.268 5.268 0 0 0-10.537-.002",
  fill: "#BEFFFC"
}), React.createElement("path", {
  d: "M12.36 46.365c0 10.04 8.14 18.182 18.181 18.182s18.18-8.141 18.18-18.182c0-10.041-8.139-18.182-18.18-18.182-10.042 0-18.182 8.14-18.182 18.182z",
  stroke: "#2B3787",
  strokeWidth: 0.4
}), React.createElement("path", {
  stroke: "#2B3787",
  strokeWidth: 0.4,
  d: "M17.573 58.698l13.034-11.631 16.62-7.568M30.54 28.183v18.884-18.424m31.283 4.888h7.353v-7.353h-7.353zm0 13.16h7.353v-7.354h-7.353zm0 13.159h7.353v-7.353h-7.353zm13.503-33.271h23.93m-23.93 6.417H93.44m-18.114 6.417h23.93m-23.93 6.417H93.44m-18.114 6.417h23.93m-23.93 6.417H93.44M15.701 95.963a4.813 4.813 0 1 0 9.627-.001 4.813 4.813 0 0 0-9.627 0zm20.32 5.559a4.811 4.811 0 0 0 4.812 4.812 4.812 4.812 0 1 0 0-9.624 4.811 4.811 0 0 0-4.812 4.812zM58.57 83.726a4.812 4.812 0 1 0 9.625.002 4.812 4.812 0 0 0-9.625-.002zm20.5 3.64a4.812 4.812 0 1 0 9.624 0 4.812 4.812 0 0 0-9.624 0zm59.757-53.836a4.813 4.813 0 1 0-9.627.001 4.813 4.813 0 0 0 9.627 0M24.792 98.002l11.229 2.406m8.924-1.504l14.538-12.333m8.623-1.905l10.93 2.106m52.114-49.129L87.157 83.864"
}), React.createElement("path", {
  d: "M134.047 41.495V79.16m-40.136 6.944h31.752",
  stroke: "#2B3787",
  strokeWidth: 0.4,
  strokeDasharray: "1,5,1,5,1,5"
}), React.createElement("path", {
  d: "M3.213 64.175v55.178c0 5.436 4.407 9.844 9.844 9.844h138.596c5.437 0 9.844-4.408 9.844-9.843v-95.31c0-5.436-4.407-9.844-9.844-9.844H13.057c-5.437 0-9.844 4.408-9.844 9.844v40.132zm158.071 50.2H3m52.032 36.111c9.4 0 9.182-7.87 9.182-7.87v-12.9m35.418 0v12.9s-.22 7.87 9.183 7.87",
  stroke: "#2B3787",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M126.107 85.922a5.268 5.268 0 1 0 10.536 0 5.268 5.268 0 0 0-10.536 0",
  fill: "#BEFFFC"
}), React.createElement("path", {
  d: "M129.346 85.92a4.811 4.811 0 0 0 4.812 4.813 4.812 4.812 0 1 0 0-9.624 4.811 4.811 0 0 0-4.812 4.812zm-10.229 7.462v7.42h7.42m0-29.679h-7.42v7.42m29.679 0v-7.42h-7.42m.001 29.678h7.419v-7.42m-12.111-9.595l-4.375 4.375m4.375-.001l-4.375-4.374M67.934 54.078l-4.374 4.375m4.374 0l-4.374-4.375M86.267 85.41l-4.374 4.376m4.374 0l-4.374-4.375m54.375-53.666l-4.375 4.375m4.375 0l-4.375-4.375M67.81 27.828l-4.376 4.375m4.376 0l-4.376-4.375m.146 15.167l1.75 1.666 2.333-3.583",
  stroke: "#2B3787",
  strokeWidth: 0.4
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 165 165",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/flow/answer.svg